<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">
            {{ "Add Component" | translate | async }}
        </span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
    <div class="ttmodal__body">
        <form class="header-form">
            <mat-form-field class="header-form-full-width">
                <mat-select placeholder="Component Type" name="componentType_" [(ngModel)]="ComponentType"
                    #componentType_="ngModel" (selectionChange)="changeComponentType($event)">
                    <mat-option [value]="type.Id" *ngFor="let type of componentTypeList">
                        {{type.Title}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="header-form-full-width">
                <mat-select placeholder="Part" name="compPart_" [(ngModel)]="selectedCompartId" #compPart_="ngModel"
                    (selectionChange)="changePartNumber($event)">
                    <mat-option [value]="type.CompartId"  [matTooltip]="type.Part_No" *ngFor="let type of compartList">
                        {{type.Part_No}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- <div class="header-form-full-width" *ngIf="isChild && childCompoentList?.length">
                <label>Child Components:</label>
                <div *ngFor="let c of childCompoentList">
                    <mat-checkbox [checked]="c.IsChild" [disabled]="c.IsChild" [(ngModel)]="c.IsChild"
                        [ngModelOptions]="{ standalone: true }" (change)="onCheckboxChange($event, c.CompartId)">
                        {{ c.CompartName }}
                    </mat-checkbox>
                </div>
            </div> -->
            <div class="header-form-full-width" *ngIf="isChild && childCompoentList?.length">
                <label>Child Components:</label>
                <div *ngFor="let c of childCompoentList">
                    <div *ngIf="c.IsChild && c.UserSelectable !== true">
                        {{ c.CompartName }}
                    </div>
                    <mat-checkbox *ngIf="c.UserSelectable === true || !c.IsChild" [(ngModel)]="c.IsChild"
                        [ngModelOptions]="{ standalone: true }" (change)="onCheckboxChange($event, c.CompartId)">
                        {{ c.CompartName }}
                    </mat-checkbox>
                </div>
            </div>

            <mat-form-field class="header-form-full-width">
                <mat-select placeholder="Brand" [(ngModel)]="SelectedMakeId" (selectionChange)="brandSelected($event)"
                    name="make">
                    <mat-option *ngFor="let make of makeList" [value]="make.Id">{{make.Name}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="header-form-full-width"
                *ngIf="isChild && childCompoentList?.length && ComponentType != 230 && ComponentType != 231 && ComponentType != 232 && ComponentType != 236" >
                <mat-select placeholder="Parent Position" [(ngModel)]="Position" name="CompPosition_" required
                    (selectionChange)="onPositionSelected($event.value)">
                    <mat-option *ngFor="let position of componentPositionSide"
                        [value]="position">{{position.Pos}}</mat-option>
                </mat-select>
            </mat-form-field>

            <div class="action-row">
                <a class="button"><span class="button__text" (click)="onNoClick()">Cancel</span></a>
                <a class="button" [ngClass]="{ 'button--primary': isSaveEnabled, 'disabled': !isSaveEnabled }"
                    (click)="isSaveEnabled && onSave()">
                    <i class="material-icons button__icon"></i>
                    <span class="button__text">{{'Save/Update' | translate | async}}</span>
                </a>
                <!-- <a class="button button--primary" (click)="onSave()">
                    <i class="material-icons button__icon"></i><span class="button__text">Save/Update</span>
                </a> -->
            </div>

        </form>
    </div>
</div>